import { render, staticRenderFns } from "./LabsRenderer.vue?vue&type=template&id=6ddf6cc4&scoped=true&"
import script from "./LabsRenderer.vue?vue&type=script&lang=js&"
export * from "./LabsRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LabsRenderer.vue?vue&type=style&index=0&id=6ddf6cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf6cc4",
  null
  
)

export default component.exports